import { render, staticRenderFns } from "./ProgramsSingleGraduates.vue?vue&type=template&id=527524d0&"
import script from "./ProgramsSingleGraduates.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleGraduates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports